/**
 * Generado por nosotros, basandonos en componentes de ADF 5.0.0
 */

import { Component, inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SearchQueryBuilderService, SearchWidget } from '@alfresco/adf-content-services';
import { KeyValue } from '@angular/common';
import { FormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SearchSelectComponent } from '../../../../search-select/search-select.component';
import { TranslationService } from '@alfresco/adf-core';
import { CustomSearchWidgetSettings } from 'projects/alden-extension/src/lib/models/custom-viewer-config';
import { APP_CONFIG_MAX_ITEMS_SELECT, NULL } from 'projects/alden-extension/src/lib/models/alden-constants';
import { AldenService } from 'projects/alden-extension/src/lib/services/alden.service';
export interface SearchListValue {
    value: string[];
    exclude: string[];
}
@Component({
    selector: 'smt-search-list',
    templateUrl: './search-list.component.html',
    styleUrls: ['./search-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'smt-search-list' }
})
export class SMTSearchListComponent implements SearchWidget, OnInit, OnDestroy{

    id: string;
    settings?: CustomSearchWidgetSettings;
    context?: SearchQueryBuilderService;
    options: KeyValue<string, string>[];
    operator: string = 'OR';
    startValue: string;
    displayValue$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    select: UntypedFormControl;
    form: UntypedFormGroup;
    private _formBuilder = inject(FormBuilder);
    filteredOptions: Observable<KeyValue<string, string>[]>;
    query: string;
    editable: boolean;

    private onDestroy$ = new Subject<boolean>();

    useChips: boolean;
    filterIsNull: boolean = false;
    allowOperatorChange: boolean;
    nullable: boolean;
    filterNullApplied: boolean = false;
    maxItems: number;

    @ViewChild(SearchSelectComponent) searchSelectComponent!: SearchSelectComponent;

    get value() : KeyValue<string, string>[] {
        return this.form?.get('select')?.value;
    }

    get exclude() : KeyValue<string, string>[] {
        return this.form?.get('exclude')?.value;
    }

    constructor(private translation: TranslationService,private aldenService:AldenService) {
        this.form =  this._formBuilder.group({
            "select": [[]],
            "exclude": [[]]
        });
        this.editable = true;
        this.allowOperatorChange = true;
        this.nullable = true;
    }

    ngOnInit(): void {
        if (this.settings) {
            this.operator = (this.settings.operator) ? this.settings.operator: this.operator;

            this.setOptions();

            if(this.settings.allowUpdateOnChange !== undefined && this.settings.allowUpdateOnChange !== null) {
                this.editable = this.settings.allowUpdateOnChange;
            }

            this.checkIfChips();
            this.checkIfNullable();
            this.allowOperatorChange = this.settings?.allowOperatorChange == true;
            this.maxItems = this.settings.maxItems ?? this.aldenService.getAppConfigProp(APP_CONFIG_MAX_ITEMS_SELECT);
        }
    }

    checkIfChips() {
        if(this.settings?.useChips !== undefined && this.settings?.useChips !== null) {
            this.useChips =  this.settings.useChips;
        }else{
            this.useChips = true;
        }
    }

    checkIfConditional(){
        if(this.settings?.allowOperatorChange !== undefined && this.settings?.allowOperatorChange !== null) {
            this.allowOperatorChange =  this.settings.allowOperatorChange;
        }
    }

    checkIfNullable(){
        if(this.settings?.nullable !== undefined && this.settings?.nullable !== null) {
            this.nullable =  this.settings.nullable;
        }
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    hasValidValue() {
        return this.value?.length > 0 || this.exclude?.length > 0 || this.filterIsNull || this.filterNullApplied;
    }

    getCurrentValue(): SearchListValue {
        return {
            value: this.value?.map(element => element.key),
            exclude: this.exclude?.map(element => element.key)
        };
    }

    getAppliedValue(): any {
        if(!this.useChips)
            return this.value;
        if(this.filterIsNull)
            return NULL;
        const val = [];
       // const val = [OPERATORS_LOAD[this.operator]];
        val.push(...this.value);
        if(this.exclude)
            val.push(...this.exclude.map(item => ({ key: '!' + item.key, value: item.value})));

        return val;
    }

    setOptions(){
        if (this.settings?.options) {
            this.options = this.settings?.options;
        }
    }

    submitValues() {
       this.updateQuery();
       this.updateDisplayValue();
    }

    refreshFilter() {
        this.setOptions();

        //Comparar el value actual contra el que tenia, para ver si cambia el contador
        let newValues: KeyValue<string, string>[] = [];
        this.value.forEach(value => {
            newValues.push(this.options.find(element => element.key === value.key));
        });

        this.exclude.forEach(value => {
            const option = this.options.find(element => element.key === value.key);
            option.key = "!" + option?.key;
            newValues.push(option);
        });

        this.setValue(newValues);

        this.updateDisplayValue();
    }

    reset() {
        if(this.form.get('select').value)
            this.form.get('select').value.splice(0);
        if(this.form.get('exclude').value)
            this.form.get('exclude').value.splice(0);
        this.filterIsNull = false;
        this.updateQuery();
        this.updateDisplayValue();
    }

    updateDisplayValue(): void {
        if (this.filterIsNull) {
            this.displayValue$.next({
                value: 'Sin valor',
                tooltip: 'Sin valor'
            });
        } else if (this.form.invalid || (this.value.length == 0 && this.exclude?.length == 0)) {
            this.displayValue$.next(null);
        } else if (this.value.length + this.exclude.length == 1) {
            const maxLength = 25;
            let value = this.value[0]?.value;
            if (!value)
                value = "NOT " + this.exclude[0].value;
            this.displayValue$.next({
                value: value.substring(0, maxLength) + (value.length > maxLength ? '...' : ''),
                tooltip: value
            });
        } else {
            this.displayValue$.next({
                value: `${this.value.length + this.exclude.length} seleccionados`,
                tooltip: this.value.map((v) => v.value).concat(this.exclude.map((v) => v.value)).join(", ")
            });
        }
    }

    updateQuery() {
        if (this.id && this.context && this.settings && this.settings.field) {
            this.filterNullApplied = this.filterIsNull;
            this.query = '';
            if(this.filterIsNull){
                this.query += `(ISNULL:'${this.settings.field}' OR ISUNSET:'${this.settings.field}' OR NOT @${this.settings.field}:[* TO *])`;
            }else if((this.value && this.value.length > 0) || (this.exclude && this.exclude.length > 0)) {
                /**Legacy para types viejos */
                if(this.settings.field == 'nodeType'){
                    this.updateQueryListLegacy();
                }else{
                    this.updateQueryList();
                }
            }
        }
        if(this.context) {
            this.context.queryFragments[this.id] = this.query;
            this.context.update();
        }
    }

    updateQueryListLegacy() {
        let filterQueryArray = []
        this.value.forEach(value => {
            filterQueryArray.push(`TYPE:'${value.key}'`);
        });
        if(this.useChips && this.exclude)
            this.exclude.forEach(value => {
                filterQueryArray.push(`-TYPE:'${value.key}'`);
            });
        this.query = '('+filterQueryArray.join(` ${this.operator} `)+')';
        this.context.queryFragments[this.id] = this.query;
    }

    updateQueryList() {
        let filterQueryArray = []
        this.value.forEach(value => {
          if (this.settings.notExactTerm) {
            filterQueryArray.push(`@${this.settings.field}:'${value.key}'`);
          } else {
            filterQueryArray.push(`=@${this.settings.field}:'${value.key}'`);
          }
        });

        const excludedTermsQueryArray:string[] = [];
        if(this.useChips && this.exclude)
            this.exclude.forEach(value => {
                excludedTermsQueryArray.push(`-@${this.settings.field}:'${value.key}'`);
            });
        this.query = "";
        if(filterQueryArray.length > 0)
            this.query += '('+filterQueryArray.join(` ${this.operator} `)+')';
        if(excludedTermsQueryArray.length > 0){
            this.query += filterQueryArray.length > 0 ? " AND " : "";
            this.query +=  "("+excludedTermsQueryArray.join(` ${this.settings?.excludeOperator ? this.settings.excludeOperator : "AND"} `)+")";
        }
        this.context.queryFragments[this.id] = this.query;
    }

    //Custom SMT
    getCurrentQuery() {
        return this.query;
    }

    setValue(value: KeyValue<string, string>[] | string) {
        if(value === undefined){
            this.form.get('select')?.setValue([]);
            this.form.get('exclude')?.setValue([])
        }else{
            let options: KeyValue<string, string>[];

            if (typeof value === 'string') {
                options = this.options.filter(opt => opt.key === value);
            } else if (Array.isArray(value) && typeof value[0] === 'string') {
                const keys = value as unknown as string[];
                options = keys
                    .map(key => this.options.find(opt => opt.key === key))
                    .filter((opt): opt is KeyValue<string, string> => opt !== undefined);
            } else {
                options = value;
            }

            const include = options.filter(item => !item.key.includes('!'));
            const exclude = options.filter(item => item.key.includes('!')).map(item => ({ key: item.key.slice(1), value: item.value }));

            this.form.get('select')?.setValue(include);
            this.form.get('exclude')?.setValue(exclude);
        }
    }

    disable() {
        this.editable = false;
        this.form.get('select').disable();
        if(this.useChips)
            this.form.get('exclude').disable();
    }

    enable() {
        this.editable = true;
        this.form.get('select').enable();
        if(this.useChips)
            this.form.get('exclude').enable();
    }

    onWidgetOpened() {
        // Para que carge la lista inicial
        this.form.get('select').setValue('');

    }

    onWidgetClosed() {
        // Para que se limpie el input
        if(this.searchSelectComponent.selectInput)
            this.searchSelectComponent.selectInput.value = '';
        // Para cerrar el desplegable si se ha quedado abierto cuando no debe
        this.searchSelectComponent.autocompleteTrigger?.closePanel();
    }

    getToolTip(value): string {
        return `${this.translation.instant('ALDEN.CUSTOM_LISTS.FILTERS.OPERATOR_TOOLTIP'+"_"+value)} `;
    }
}
